import React, { Component } from 'react';

export class CustomField extends Component {
    render() {
        const { id, label, required, children, displayLabel, errors } = this.props;
        let className = "";
        if (displayLabel === true) {
            return (
                <div className={className} style={{ marginBottom: '10px' }}>
                    <label htmlFor={id}><b>{label}{required ? "*" : null}</b></label>
                    {children}
                    {errors}
                </div>
            );
        } else {
            return (
                <div className={className} style={{ marginBottom: '10px' }}>
                    {children}
                    {errors}
                </div>
            );
        }
    }
}